import { c as _c } from "react/compiler-runtime";
// Bottom blue wash on the celebration shell — matches the Figma blur layer.

import { OG_DIMENSIONS } from '../../tokens';
export function OgCelebrationOverlay() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div style={{
      position: "absolute",
      left: 0,
      top: 258,
      width: OG_DIMENSIONS.width,
      height: 372,
      display: "flex",
      background: "linear-gradient(180deg, rgba(0, 0, 255, 0) 0%, rgba(0, 0, 255, 0.5) 100%)",
      pointerEvents: "none"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}